export const Representment = {
  'MAX_REPRESENTMENTS':'REPRESENTMENTS-MAX_REPRESENTMENTS',
  'FIRST_VALUE_DATE_ADJUSTMENT':'REPRESENTMENTS-FIRST_VALUE_DATE_ADJUSTMENT',
  'FIRST_NUMBER_OF_DAYS':'REPRESENTMENTS-FIRST_NUMBER_OF_DAYS',
  'FIRST_CYCLE_TYPE':'REPRESENTMENTS-FIRST_CYCLE_TYPE',
  'FIRST_DAY_OF_WEEK':'REPRESENTMENTS-FIRST_DAY_OF_WEEK',
  'FIRST_DAY_OF_MONTH':'REPRESENTMENTS-FIRST_DAY_OF_MONTH',
  'SUBSEQUENT_VALUE_DATE_ADJ':'REPRESENTMENTS-SUBSEQUENT_VALUE_DATE_ADJ',
  'SUBSEQUENT_NUMBER_OF_DAYS':'REPRESENTMENTS-SUBSEQUENT_NUMBER_OF_DAYS',
  'SUBSEQUENT_CYCLE_TYPE':'REPRESENTMENTS-SUBSEQUENT_CYCLE_TYPE',
  'SUBSEQUENT_DAY_OF_WEEK':'REPRESENTMENTS-SUBSEQUENT_DAY_OF_WEEK',
  'SUBSEQUENT_DAY_OF_MONTH':'REPRESENTMENTS-SUBSEQUENT_DAY_OF_MONTH',
  'LATE_RETURN_ACTION':'REPRESENTMENTS-LATE_RETURN_ACTION',
}
